import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.einlasskontrolle-rolle-berechtigung-setzen';
import * as api from '../../../clients/einlasskontrolle';

@Injectable()
export class EinlasskontrolleEinlasskontrolleRolleBerechtigungSetzenEffects {

    EinlasskontrolleRolleBerechtigungSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_EINLASSKONTROLLE_ROLLE_BERECHTIGUNG_SETZEN),
        mergeMap((x: ac.PostEinlasskontrolleRolleBerechtigungSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postEinlasskontrolleRolleBerechtigungSetzen(x.einlasskontrolleRolleOptionenRequest).pipe(
                map((result: any) => {
                    return new ac.PostEinlasskontrolleRolleBerechtigungSetzenErfolgreichAction(result, x.einlasskontrolleRolleOptionenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostEinlasskontrolleRolleBerechtigungSetzenFehlerAction(error, x.einlasskontrolleRolleOptionenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.EinlasskontrolleCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.EinlasskontrolleCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.EinlasskontrolleCommandService);
        }
        return this.service;
    }
}
